module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', [_vm._v("意见反馈成功")]), _vm._v(" "), _c('p', [_vm._v("已收到您的建议，真相搜索团队将尽快为您处理！")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/user/Success.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42143758"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/others/Success.vue
// module id = 764
// module chunks = 1